import { AccountReport } from 'core/models/AccountReport';
import { Card, Col, Row } from 'react-bootstrap';
import { formatCurrency, formatDateParams } from 'shared/utils';

export const AccountDetails = (props: { accountData: AccountReport; periodo: any }) => {
  return (
    <Card>
      <Card.Header className="text-center">
        {props.accountData.denominacionCuenta}
      </Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <p className="fw-semibold">
              Saldo inicial: {formatCurrency(props.accountData.saldoInicial)}
            </p>
          </Col>
          <Col>
            <p className="fw-semibold">
              Saldo disponible: {formatCurrency(props.accountData.saldoDisponible)}
            </p>
          </Col>
        </Row>
        <p className="fw-semibold text-center">{formatDateParams(props.periodo)}</p>
      </Card.Body>
    </Card>
  );
};
